module.exports = __webpack_public_path__ + "img/logo_iguard.a500e319.svg";